@let column = columnSg();

<div class="atn-mosaic-grid-column">
  @for (item of column.elements; track $index) {
    <div
      class="atn-mosaic-grid-column__element"
      [style.minHeight.px]="item.height"
      [style.flex]="item.height"
    >
      <atn-mosaic-grid-element [element]="item.element" />
    </div>
  }
</div>
